module.exports = __webpack_public_path__ + "static/media/cssda-innovation-4-Seasons-Slot-Machine_25_07_2022.35aafc1e.pdf";